import parse from 'html-react-parser'
import Head from 'next/head'
import { useRouter } from 'next/router'

import { FRONT_BASE_URL } from '@/constants'

import { WPPageData } from '@/types'

type MetaProps = {
  pageProps: WPPageData
}

const Meta = ({ pageProps }: MetaProps) => {
  const { asPath, locale, defaultLocale } = useRouter()

  // canonical self-referenziale (la x-default e' sempre la lingua di default)
  const canonical = `${FRONT_BASE_URL}${
    locale && locale !== defaultLocale ? `/${locale}` : ''
  }${asPath.split(/[?#]/)[0]}`

  const robotsContent = [
    pageProps?.meta_robots?.is_robots_noindex ? 'noindex' : 'index',
    pageProps?.meta_robots?.is_robots_nofollow ? 'nofollow' : 'follow'
  ]
    .filter(Boolean)
    .join(', ')

  // le pagine tassonomia hanno yoast_head dentro `object`
  const yoastHead =
    pageProps?.yoast_head || (pageProps as any)?.object?.yoast_head

  return yoastHead ? (
    <Head>
      {parse(
        yoastHead
          .replace(/"\//g, `"${FRONT_BASE_URL}/`)
          .replace(
            /(<meta property="og:url" content=")[^"]*"/,
            `$1${canonical}"`
          )
      )}
      <link rel="canonical" href={canonical} />
      {robotsContent ? <meta name="robots" content={robotsContent} /> : null}

      {pageProps?.wpml_translations?.length > 0
        ? pageProps.wpml_translations.map((translation, index) => (
            <link
              key={`${translation.id}${index}`}
              rel="alternate"
              hrefLang={translation.code || translation.locale?.slice(0, 2)}
              href={`${FRONT_BASE_URL}${translation.href}`}
            />
          ))
        : null}

      {pageProps?.xdefault_translation?.length > 0
        ? pageProps.xdefault_translation.map((translation, index) => (
            <link
              key={`${translation.id}${index}`}
              rel="alternate"
              hrefLang="x-default"
              href={`${FRONT_BASE_URL}${translation.href}`}
            />
          ))
        : null}
    </Head>
  ) : null
}

export default Meta
